var S = /* @__PURE__ */ ((I) => (I[I.UNIT = 0] = "UNIT", I[I.SHOWINGS = 1] = "SHOWINGS", I[I.WAITING_LIST = 2] = "WAITING_LIST", I))(S || {});
export {
  S as NotFoundMessageType
};
//# sourceMappingURL=NotFoundMessage.utils.js.map
